// extracted by mini-css-extract-plugin
module.exports = {"chip":"AssignToSelect_chip__MyHQ7","Avatar":"AssignToSelect_Avatar__ZK89_","text":"AssignToSelect_text__g5mnN","Menu":"AssignToSelect_Menu__inONV"};